import script from "./ReservationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservationPage.vue?vue&type=script&setup=true&lang=js"

import "./ReservationPage.vue?vue&type=style&index=0&id=3263d56d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3263d56d"]])

export default __exports__